import Vue from "vue";
import Vuex from "vuex";

import app from "./modules/app";
import notify from "./modules/notify";
import session from "./modules/session";
import company from "./modules/company";
import systemModules from "./modules/systemModules";
import groups from "./modules/groups";
import users from "./modules/users";
import usertypes from "./modules/usertypes";
import permission from "./modules/permission";
import garageaccredited from "./modules/garageaccredited";
import bankaccount from "./modules/bankaccount";
import maintancereason from "./modules/maintancereason";
import activestype from "./modules/activestype";
import manufacturer from "./modules/manufacturer";
import active from "./modules/active";
import model from "./modules/model";
import os from "./modules/os";
import vehicletypes from "./modules/vehicletypes";
import contracts from "./modules/contracts";
import servicetypes from "./modules/servicetypes";
import statusostests from "./modules/statusostests";
import ostests from "./modules/ostests";
import extract from "./modules/extract";
import vehiclebrands from "./modules/vehiclebrands";
import commandtypes from "./modules/commandtypes";
import overlay from "./modules/overlay";
import banks from "./modules/banks";
import dashboard from "./modules/dashboard";
import activestatus from "./modules/activestatus";
import status from "./modules/status";
import movementtype from "./modules/movementtype";
import component from "./modules/component";
import stockalerts from "./modules/stockalerts";
import ossw from "./modules/ossw";
import bstable from "./modules/bstable";
import filtershistory from "./modules/filtershistory";
import arena from "./modules/arena";
import frotix from "./modules/frotix";
import causeofmaintance from "./modules/causeofmaintance";
import acessories from "./modules/acessories";
import financial from "./modules/financial";
import frota from "./modules/frota";
import toast from "./modules/toast";
import origin from "./modules/origin";
import integrator from "./modules/integrator";
import shippingmethodtransportation from "./modules/shippingmethodtransportation";
import shippingdestinytransportation from "./modules/shippingdestinytransportation";
import costmaterialtransportation from "./modules/costmaterialtransportation";
import sync from "./modules/sync";
import vehicleevolution from "./modules/vehicleevolution";
import consultant from "./modules/consultant";
import financialservice from "./modules/financialservice";
import frequency from "./modules/frequency";
import drivergroups from "./modules/drivergroups";
import ibge from "./modules/ibge";
import temperaturesensordelay from "./modules/temperaturesensordelay";
import rfidreaderdelay from "./modules/rfidreaderdelay";
import position from "./modules/position";
import atendimentos from "./modules/atendimentos"
import infractiontype from "./modules/infractiontype"

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app,
    session,
    notify,
    company,
    systemModules,
    groups,
    users,
    usertypes,
    permission,
    garageaccredited,
    bankaccount,
    maintancereason,
    activestype,
    manufacturer,
    active,
    model,
    os,
    vehicletypes,
    contracts,
    servicetypes,
    statusostests,
    ostests,
    extract,
    vehiclebrands,
    commandtypes,
    overlay,
    banks,
    dashboard,
    activestatus,
    status,
    movementtype,
    component,
    stockalerts,
    ossw,
    bstable,
    filtershistory,
    arena,
    frotix,
    causeofmaintance,
    acessories,
    financial,
    frota,
    toast,
    origin,
    integrator,
    shippingmethodtransportation,
    shippingdestinytransportation,
    costmaterialtransportation,
    sync,
    vehicleevolution,
    consultant,
    financialservice,
    frequency,
    drivergroups,
    ibge,
    temperaturesensordelay,
    rfidreaderdelay,
    position,
    atendimentos,
    infractiontype
  },
});
